import { Injectable } from '@angular/core';

@Injectable()
export class ImageService {
  getFileSrc(fileName: string): string {
    if (window.location.hostname === 'localhost') {
      return `/assets/${fileName}`;
    }
    return `https://vstatic-prod.apigateway.co/marketplace-public-store.9223372035070149761.prod/assets/${fileName}`;
  }
}
